import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import router from "@/router";
import { isTokenExpired, getTimeUntilExpiration } from "@/utils/jwt";

const store = createStore({
  plugins: [createPersistedState()],
  state: {
    token: null,
    user: null,
    selectedPath: null,
  },
  getters: {
    isTokenExpired: (state) => {
      return !state.token || isTokenExpired(state.token);
    },
    getTimeUntilExpiration: (state) => {
      return state.token ? getTimeUntilExpiration(state.token) : 0;
    },
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
    },
    setUser(state, user) {
      state.user = user;
    },
    setSelectedPath(state, path) {
      state.selectedPath = path;
    },
  },
  actions: {
    logout({ commit }, payload = {}) {
      // Réinitialiser les données d'authentification
      commit("setToken", null);
      commit("setUser", null);
      commit("setSelectedPath", null);

      // Nettoyer le localStorage
      localStorage.removeItem("tokenDate");
      sessionStorage.removeItem("token");

      // Afficher un message selon la raison de la déconnexion
      const reason = payload.reason;
      if (reason === "expired") {
        console.log("Session expirée - redirection vers login");
      } else if (reason === "unauthorized") {
        console.log("Session invalide - redirection vers login");
      }

      // Rediriger vers la page de connexion
      router.push({ path: "/login" });
    },
    setSelectedPath({ commit }, path) {
      commit("setSelectedPath", path);
    },
  },
  modules: {},
});

export default store;
